import React from 'react';
import { TrygHeader } from './styles';

export default () => {
  return <TrygHeader>Reset password</TrygHeader>;
};
